import React from "react";
import PropTypes from "prop-types";
import Radio from "../../../shared/Radio/Radio";
import {
	Button,
	MaxModal,
	Heading
} from "@maxmilhas/hangar-components-atomic/public";
import Textarea from "../../../shared/Textarea/Textarea";

const ModalReportProblem = ({
    options,
    opened,
    disabled,
    onClose,
    onChangeOption,
    onChangeMessage,
    onSubmit
}) => {
    return (
        <MaxModal open={opened} onClose={onClose}>
            <div className="my-offers__reportProblemModal">
                <Heading color="#223254" tag="h5">
                    Qual o problema você está enfrentando?
                </Heading>
                <Radio
                    onChange={onChangeOption}
                    horizontally={false}
                    options={options}
                    name="modal-report-problem"
                />
                <Textarea
                    onChange={onChangeMessage}
                    placeholder="Conte mais pra gente"
                />
                <Button
                    size="normal"
                    disabled={disabled}
                    onClick={onSubmit}
                >
                    Enviar
                </Button>
            </div>
        </MaxModal>
    )
}

ModalReportProblem.propTypes = {
    options: PropTypes.array,
	opened: PropTypes.bool,
    disabled: PropTypes.bool,
    onClose: PropTypes.func,
    onChangeOption: PropTypes.func,
    onChangeMessage: PropTypes.func,
    onSubmit: PropTypes.func
};

export default ModalReportProblem;